/**
 * USSA Order History — vanilla JS table with search, sort, pagination.
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('[data-order-history]');
    if (!section) return;

    var customerEmail = section.dataset.customerEmail;
    var wrapper = section.querySelector('[data-table-wrapper]');
    var tbody = section.querySelector('[data-table-body]');
    var searchInput = section.querySelector('[data-search]');
    var loadingState = section.querySelector('[data-loading-state]');
    var emptyState = section.querySelector('[data-empty-state]');
    var pageInfo = section.querySelector('[data-page-info]');
    var prevBtn = section.querySelector('[data-page-prev]');
    var nextBtn = section.querySelector('[data-page-next]');
    var modal = section.querySelector('[data-order-modal]');
    var modalBody = modal ? modal.querySelector('[data-order-body]') : null;
    var modalClose = modal ? modal.querySelector('[data-modal-close]') : null;

    if (!customerEmail || !tbody) {
      if (loadingState) loadingState.style.display = 'none';
      if (emptyState) {
        emptyState.textContent = customerEmail ? 'Unable to load orders.' : 'Please log in to view your order history.';
        emptyState.style.display = 'block';
      }
      return;
    }

    var PER_PAGE = 15;
    var allData = [];
    var filtered = [];
    var sortKey = 'ordernumber';
    var sortDir = -1; // -1 = desc
    var page = 0;

    /* ── Helpers ── */
    function currency(amount, cur) {
      return parseFloat(amount).toLocaleString('en-US', { style: 'currency', currency: cur });
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    /* ── Fetch ── */
    function fetchOrderHistory() {
      return fetch('https://ussa.greaterthannice.com/api/main/ussa-order-history', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'email=' + encodeURIComponent(customerEmail),
      })
        .then(function (r) { return r.json(); })
        .then(function (j) { return j.data || []; })
        .catch(function (e) { console.error('Fetch error:', e); return []; });
    }

    function fetchOrderDetail(ordernumber) {
      return fetch('https://ussa.greaterthannice.com/api/main/get_order_by_order_number', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'order_number=' + encodeURIComponent(ordernumber),
      })
        .then(function (r) { return r.json(); })
        .then(function (j) { return j.data ? j.data[0] : null; })
        .catch(function (e) { console.error('Fetch error:', e); return null; });
    }

    /* ── Build rows from API data ── */
    function createTableData(data) {
      return data
        .filter(function (item) { return !item.retailOrder; })
        .map(function (item) {
          var sum = parseFloat(item.freightAmount) + parseFloat(item.bookedAmount);
          return {
            date: item.entered || '',
            ordernumber: item.order || '',
            ponumber: item.customerPurchaseOrder || '',
            status: item.status || '',
            subtotal: sum.toLocaleString('en-US', { style: 'currency', currency: item.currency }),
            _subtotalRaw: sum,
          };
        });
    }

    /* ── Search ── */
    function applyFilter() {
      var q = (searchInput.value || '').toLowerCase();
      if (!q) {
        filtered = allData.slice();
      } else {
        filtered = allData.filter(function (row) {
          return (
            row.date.toLowerCase().indexOf(q) !== -1 ||
            row.ordernumber.toLowerCase().indexOf(q) !== -1 ||
            row.ponumber.toLowerCase().indexOf(q) !== -1 ||
            row.status.toLowerCase().indexOf(q) !== -1 ||
            row.subtotal.toLowerCase().indexOf(q) !== -1
          );
        });
      }
      applySort();
    }

    /* ── Sort ── */
    function applySort() {
      filtered.sort(function (a, b) {
        var va = a[sortKey];
        var vb = b[sortKey];
        if (sortKey === '_subtotalRaw' || sortKey === 'subtotal') {
          va = a._subtotalRaw;
          vb = b._subtotalRaw;
        }
        if (va < vb) return -1 * sortDir;
        if (va > vb) return 1 * sortDir;
        return 0;
      });
      page = 0;
      render();
    }

    /* ── Render ── */
    function render() {
      var start = page * PER_PAGE;
      var end = start + PER_PAGE;
      var rows = filtered.slice(start, end);
      var totalPages = Math.ceil(filtered.length / PER_PAGE);

      tbody.innerHTML = '';
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        var tr = document.createElement('tr');
        tr.dataset.ordernumber = r.ordernumber;
        tr.innerHTML =
          '<td>' + escapeHtml(r.date) + '</td>' +
          '<td>' + escapeHtml(r.ordernumber) + '</td>' +
          '<td>' + escapeHtml(r.ponumber) + '</td>' +
          '<td>' + escapeHtml(r.status) + '</td>' +
          '<td>' + escapeHtml(r.subtotal) + '</td>';
        tbody.appendChild(tr);
      }

      // Page info
      if (filtered.length === 0) {
        pageInfo.textContent = 'No results';
      } else {
        pageInfo.textContent = (start + 1) + '\u2013' + Math.min(end, filtered.length) + ' of ' + filtered.length;
      }

      prevBtn.disabled = page === 0;
      nextBtn.disabled = page >= totalPages - 1;

      // Sort indicator
      var ths = section.querySelectorAll('.ussa-oh__table thead th[data-sort]');
      for (var t = 0; t < ths.length; t++) {
        ths[t].classList.remove('sort-asc', 'sort-desc');
        if (ths[t].dataset.sort === sortKey) {
          ths[t].classList.add(sortDir === 1 ? 'sort-asc' : 'sort-desc');
        }
      }
    }

    /* ── Events ── */
    searchInput.addEventListener('input', function () {
      applyFilter();
    });

    prevBtn.addEventListener('click', function () {
      if (page > 0) { page--; render(); }
    });

    nextBtn.addEventListener('click', function () {
      var totalPages = Math.ceil(filtered.length / PER_PAGE);
      if (page < totalPages - 1) { page++; render(); }
    });

    // Column sort
    section.querySelectorAll('.ussa-oh__table thead th[data-sort]').forEach(function (th) {
      th.addEventListener('click', function () {
        var key = th.dataset.sort;
        if (sortKey === key) {
          sortDir *= -1;
        } else {
          sortKey = key;
          sortDir = key === 'ordernumber' ? -1 : 1;
        }
        applySort();
      });
    });

    // Row click → open modal
    tbody.addEventListener('click', function (e) {
      var row = e.target.closest('tr');
      if (!row || !row.dataset.ordernumber) return;
      openModal(row.dataset.ordernumber);
    });

    /* ── Modal ── */
    function openModal(ordernumber) {
      if (!modal || !modalBody) return;
      modalBody.innerHTML = '<p class="ussa-oh-detail__loading">Loading order details\u2026</p>';
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      fetchOrderDetail(ordernumber).then(function (item) {
        if (item) {
          modalBody.innerHTML = renderModal(item);
        } else {
          modalBody.innerHTML = '<p>Unable to load order details.</p>';
        }
      });
    }

    function closeModal() {
      modal.style.display = 'none';
      modalBody.innerHTML = '';
      document.body.style.overflow = '';
    }

    function renderModal(item) {
      var cur = item.currency;
      var subtotal = parseFloat(item.bookedAmount);
      var freight = parseFloat(item.freightAmount);
      var total = subtotal + freight;
      var date = new Date(item.createdOn).toISOString().substring(0, 10);

      var html = '<div class="ussa-oh-detail">';
      html += '<div class="ussa-oh-detail__header">';
      html += '<h2 class="ussa-oh-detail__order-no">Order #' + escapeHtml(item.order) + '</h2>';
      html += '<p class="ussa-oh-detail__po">PO: ' + escapeHtml(item.customerPurchaseOrder) + '</p>';
      html += '<p class="ussa-oh-detail__date">Date: ' + date + '</p>';
      html += '</div>';

      html += '<div class="ussa-oh-detail__table-wrap"><table class="ussa-oh-detail__table">';
      html += '<thead><tr><th>Product</th><th>Style / Color</th><th>Size / Qty</th><th>Total</th></tr></thead><tbody>';

      for (var i = 0; i < item.lineItems.length; i++) {
        var li = item.lineItems[i];
        var sizes = '';
        for (var s = 0; s < li.sizes.length; s++) {
          if (li.sizes[s].bookQuantity > 0) {
            sizes += escapeHtml(li.sizes[s].sizeName) + ' &times; ' + li.sizes[s].bookQuantity + '<br>';
          }
        }
        var lineTotal = li.openAmount_tc > 0 ? currency(li.openAmount_tc, cur) : '';
        html += '<tr>';
        html += '<td>' + escapeHtml(li.style) + ' - ' + escapeHtml(li.styleDescription) + '</td>';
        html += '<td>' + escapeHtml(li.style) + ' ' + escapeHtml(li.color) + '</td>';
        html += '<td>' + sizes + '<span class="ussa-oh-detail__qty-total">Total: ' + li.bookedTotal + '</span></td>';
        html += '<td>' + lineTotal + '<br><span class="ussa-oh-detail__unit-price">' + currency(li.price, cur) + ' / unit</span></td>';
        html += '</tr>';
      }

      html += '</tbody></table></div>';

      html += '<div class="ussa-oh-detail__totals">';
      html += '<div class="ussa-oh-detail__totals-row"><span>Subtotal</span><span>' + currency(subtotal, cur) + '</span></div>';
      html += '<div class="ussa-oh-detail__totals-row"><span>' + escapeHtml(item.shipviaDescription) + '</span><span>' + currency(freight, cur) + ' <em>*Est. until invoiced</em></span></div>';
      html += '<div class="ussa-oh-detail__totals-row ussa-oh-detail__totals-row--grand"><span>Total</span><span>' + currency(total, cur) + '</span></div>';
      html += '</div>';

      html += '<div class="ussa-oh-detail__addresses">';
      html += '<div class="ussa-oh-detail__address-card"><h3>Billing</h3>';
      html += '<p class="ussa-oh-detail__term">Payment: ' + escapeHtml(item.termDescription) + '</p>';
      if (item.billToAddress1) {
        html += '<p>' + escapeHtml(item.billToStoreName) + '<br>' + escapeHtml(item.billToAddress1);
        if (item.billToAddress2) html += '<br>' + escapeHtml(item.billToAddress2);
        html += '<br>' + escapeHtml(item.billToCity) + ', ' + escapeHtml(item.billToState) + ' ' + escapeHtml(item.billToZip);
        html += '<br>' + escapeHtml(item.billToCountryCode) + '</p>';
      }
      html += '</div>';

      html += '<div class="ussa-oh-detail__address-card"><h3>Shipping</h3>';
      html += '<p class="ussa-oh-detail__term">Status: ' + escapeHtml(item.orderStatusReasonDescription) + '</p>';
      if (item.shipToAddress1) {
        html += '<p>' + escapeHtml(item.shipToStoreName) + '<br>' + escapeHtml(item.shipToAddress1);
        if (item.shipToAddress2) html += '<br>' + escapeHtml(item.shipToAddress2);
        html += '<br>' + escapeHtml(item.shipToCity) + ', ' + escapeHtml(item.shipToState) + ' ' + escapeHtml(item.shipToZip);
        html += '<br>' + escapeHtml(item.shipToCountryCode) + '</p>';
      }
      html += '</div></div></div>';
      return html;
    }

    if (modalClose) modalClose.addEventListener('click', closeModal);
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.style.display === 'flex') closeModal();
      });
    }

    /* ── Init ── */
    fetchOrderHistory().then(function (data) {
      if (loadingState) loadingState.style.display = 'none';
      allData = createTableData(data);

      if (allData.length === 0) {
        if (emptyState) emptyState.style.display = 'block';
        return;
      }

      wrapper.style.display = 'block';
      filtered = allData.slice();
      applySort();
    });
  });
})();
